export enum FineGrainedAuthItemsEnum {
    KPI_DATA= 'kpi-data',
    SUPER_LICENCES_MANAGER= 'super-licenses-manager',
}
export default FineGrainedAuthItemsEnum
